import { render } from "./InvoiceApproval.vue?vue&type=template&id=a8464082"
import script from "./InvoiceApproval.vue?vue&type=script&lang=js"
export * from "./InvoiceApproval.vue?vue&type=script&lang=js"

import "./InvoiceApproval.vue?vue&type=style&index=0&id=a8464082&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__